const identificationRepository = (fetch: CustomFetch) => ({
  async getCoverageInfo(srId?: string, legislation?: Legislation) {
    const urlParam = srId ?? legislation ?? ''
    if (!urlParam) return { isCovered: false }

    const { covered: isCovered } = await fetch<{ covered: boolean }>(`/v1/user/identification/payment/${urlParam}`)

    return { isCovered }
  },
  async getIdentMethod(srId: string, sid: string) {
    return await fetch<IdentMethod>(`/v3/signature-requests/${srId}/signatures/${sid}/ident-method`)
  },
})

export default identificationRepository
